const SearchForm = require('../ui/search');
const DeckHeader = require('../decklist/deck-header');
const CommonsService = require('../../services').Commons;
const template = require('./commons.tpl').default;

module.exports = DomClass(template, function Commons() {
	var _t = this;

	this.page_size = 15;

	this.search = function(query, after, keep_url) {
		this.searchform.item = query;
		this.searchform.search(query, after, keep_url);
	};

	this.searchform.getResults = function(query, after, keep_url) {
		after = after || '';
		if (!keep_url) {
			var search_url = '?shared/~/' + query + '/gt/' + after;
			history.pushState(search_url, search_url, search_url);
		}

		api_page_size = _t.page_size + 1;
		return CommonsService.getIndex(query, after, api_page_size).then(function(results) {
			if (results.length > _t.page_size) {
				results.pop();
				var next = '?shared/~/' + query + '/gt/' + results[results.length - 1].$id;
			} else {
				var next = '';
			}

			return {
				items: results.map(function(deck) {
					var d = new DeckHeader(deck);
					d.endpoint = 'shared';
					return d;
				}),
				next: next
			};
		});
	};

});
